import React, { Component, PureComponent } from 'react'
import { Button, Grid, Tooltip } from '@material-ui/core'
import LeaflyMapCategories from './LeaflyMapCategories'
import { hasAccess } from '../../utils/api'

class LeaflyMenu extends PureComponent {
  syncMenu = () => {
    this.props.syncLeaflyAccount()
  }

  render() {
    const { leaflyAccount = {}, categoryList = [], lastModified = null } = this.props

    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid container>
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <h1>Manage Menu</h1>
              </Grid>
              <Grid item xs={12} sm={12} md={8} lg={9} className="btns-mb">
                {hasAccess() ? (
                  <div className="pull-right">
                    <Tooltip title="It could take up to 15 minutes for you to see your products sync to Leafly">
                      <Button className="primary-button margin" onClick={this.syncMenu}>
                        Sync to Leafly
                      </Button>
                    </Tooltip>
                  </div>
                ) : null}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <LeaflyMapCategories
              leaflyAccount={leaflyAccount}
              categoryList={categoryList}
              onSave={this.props.onSave}
              syncLeaflyAccount={this.props.syncLeaflyAccount}
              onError={this.props.onError}
              lastModified={lastModified}
            />
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default LeaflyMenu



// WEBPACK FOOTER //
// ./src/components/Leafly/LeaflyMenu.js